export default __webpack_public_path__ + "static/media/angle-down-light_blue.f946046e.svg";